import { useState, useCallback, useEffect } from 'react';
import { AsyncLifecycle } from '.';

export const useAsync = (asyncFunction, immediate = true) => {
  const [status, setStatus] = useState(AsyncLifecycle.IDLE);
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  // The execute function wraps asyncFunction and
  // handles setting state for pending, value, and error.
  // useCallback ensures the below useEffect is not called
  // on every render, but only if asyncFunction changes.
  const execute = useCallback(() => {
    setStatus(AsyncLifecycle.PENDING);
    setValue(null);
    setError(null);
    return asyncFunction()
      .then((response) => {
        setValue(response);
        setStatus(AsyncLifecycle.FULFILLED);
      })
      .catch((error) => {
        setError(error);
        setStatus(AsyncLifecycle.REJECTED);
      });
  }, [asyncFunction]);
  // Call execute if we want to fire it right away.
  // Otherwise execute can be called later, such as
  // in an onClick handler.
  useEffect(() => {
    if (immediate) {
      execute();
    }
  }, [execute, immediate]);
  return { execute, status, value, error };
};
